import { render } from "./DashboardCertificatesShow.vue?vue&type=template&id=1592f3dc&scoped=true"
import script from "./DashboardCertificatesShow.vue?vue&type=script&lang=js"
export * from "./DashboardCertificatesShow.vue?vue&type=script&lang=js"

import "./DashboardCertificatesShow.vue?vue&type=style&index=0&id=1592f3dc&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1592f3dc"]])

export default __exports__